/**
 * @ngdoc controllers
 * @memberof mercury.modules.settings
 * @name SettingsNewCompanyCtrl
 */
angular.module('mercury.modules.settings.company')
  .controller('SettingsNewCompanyCtrl', ["$http", "title", "$scope", "settings", "localStorageService", "$state", "userinfo", "dialog", "$timeout", function($http, title, $scope, settings, localStorageService, $state, userinfo, dialog, $timeout) {
    title.set('Tell us about your business');

    $scope.step = 1;
    $scope.signUpFields = false;
    $scope.signUpResellerField = false;
    $scope.signUpPromoField = false;

    $scope.isButtonDisabled = true;

    $scope.newCompanyForm = {};

    $scope.sessionToken = Math.floor((Math.random() * 12321) + 1);
    var doneTypingInterval = 400;
    $scope.typingTimer = false;
    $scope.places = [];
    $scope.count = 0;
    $scope.buttonText = 'Complete Sign Up →';
    $scope.disabled = false;
    $scope.addressSet = false;
    $scope.loading = false;

    $scope.VenueAddress = '';
    $scope.City = '';
    $scope.country = '';
    $scope.placeId = '';
    $scope.postcode = '';
    $scope.state = '';
    $scope.suburb = '';
    $scope.ResellerCode = '';
    $scope.PromoCode = '';
    $scope.businessType = '';

    $scope.tiles = [
      {name: 'Restaurant', value: 'Restaurant' , icon: '/App/images/icons/s-restaurant.svg', selected: false},
      {name: 'Cafe', value: 'Cafe' , icon: '/App/images/icons/s-cafe.svg', selected: false},
      {name: 'Pub', value: 'Pub' , icon: '/App/images/icons/s-pub.svg', selected: false},
      {name: 'Bar', value: 'Bar' , icon: '/App/images/icons/s-bar.svg', selected: false},
      {name: 'Nightclub', value: 'Nightclub' , icon: '/App/images/icons/s-nightclub.svg', selected: false},
      {name: 'Bar Restaurant', value: 'BarAndRestaurant' , icon: '/App/images/icons/s-bar-restaurant.svg', selected: false},
      {name: 'Gastro Pub', value: 'GastroPub' , icon: '/App/images/icons/s-gastro-pub.svg', selected: false},
      {name: 'Quick Service', value: 'QuickService' , icon: '/App/images/icons/s-quick-service.svg', selected: false}
    ];

    $scope.update = function($event, $scopeName) {
      $scope.newCompanyForm[$scopeName] = $event.target.value;
    };

    $scope.setBusinessType = function(val) {
      $scope.businessType = val;
      $scope.newCompanyForm.BusinessType = val;
      $scope.isButtonDisabled = false;
    };

    $scope.toggleFields = function() {
      $scope.signUpFields = !$scope.signUpFields;
    };

    $scope.toggleResellerField = function() {
      $scope.signUpResellerField = !$scope.signUpResellerField;
    };
    $scope.togglePromoField = function() {
      $scope.signUpPromoField = !$scope.signUpPromoField;
    };

    $scope.goBack = function() {
      $scope.step = 1;
    };

    $scope.signUpContinue = function() {
      if ($scope.newCompanyForm.BusinessType !== undefined) {
        $scope.step = 2;
      }
    };

    var addressChange = function() {

      var requestParams = {
        search: $scope.address,
        sessiontoken: $scope.sessionToken,
        types: 'address'
      };

      if ($scope.address !== '') {
        $http
          .get(settings.apiHost + '/r/Places', {params: requestParams})
          .then(function(response) {
            $scope.places = response.data;
            $scope.addressIsInvalid = $scope.places.length == 0;
          });
      } else {
        $scope.places = [];
      }
    };

    $scope.changeAddressSet = function() {
      $scope.addressSet = !$scope.addressSet;
    };

    $scope.setPlace = function(placeId) {
      var requestParams = {
        sessiontoken: $scope.sessionToken
      };

      $http
      .get(settings.apiHost + '/r/Places/' + placeId, {params: requestParams})
        .then(function(response) {
          $scope.city = response.data.city;
          $scope.country = response.data.country;
          $scope.VenueAddress = response.data.formattedAddress;
          $scope.FormattedAddress = response.data.formattedAddress;
          $scope.addressSet = true;

          $scope.placeId = response.data.placeId;
          $scope.postcode = response.data.postcode;
          $scope.state = response.data.state;
          $scope.suburb = response.data.suburb;

          $scope.newCompanyForm.address = response.data.name;
          $scope.newCompanyForm.City = response.data.city;
          $scope.newCompanyForm.country = response.data.country;
          $scope.newCompanyForm.placeId = response.data.placeId;
          $scope.newCompanyForm.postcode = response.data.postcode;
          $scope.newCompanyForm.state = response.data.state;
          $scope.newCompanyForm.suburb = response.data.suburb;

          $scope.places = [];
        });

    };

    $scope.keyUp = function($event) {
      clearTimeout($scope.typingTimer);
      $scope.address = $event.target.value;
      $scope.typingTimer = setTimeout(addressChange, doneTypingInterval);
    };

    $scope.keyDown = function() {
      clearTimeout($scope.typingTimer);
    };

    $scope.createCompany = function() {

      if ($scope.newCompanyForm.$invalid || !$scope.addressSet) {
        return;
      }

      $scope.disabled = true;
      $scope.buttonText = 'Creating Company... We\'re nearly there...';
      $scope.loading = true;

      $http.post(settings.apiHost + '/r/Companies', $scope.newCompanyForm)
      .then(function(response) {

        sessionStorage.activeCompany = response.data.id;
        localStorageService.set('defaultCompany', response.data.id);
        // localStorageService.set('company-created', true);

        //Reinitialise User and then Redirect...
        userinfo.initialize().then(function() {

          $timeout(function() {
            dialog.open({
              size: 'lg',
              templateUrl: 'dialogs/welcome/welcomenoposdialog.tpl.html',
              controller: 'WelcomeDialogCtrl'
            });
          }, 3000);

          var $firstRedirect = 'Stock.ReportOverview';
          localStorageService.set('first-redirect', $firstRedirect);

          $state.go($firstRedirect);
        });

      }, function(response) {
        $scope.disabled = false;
        $scope.buttonText = 'Complete Sign Up →';
        $scope.loading = false;

        if ((response.status === 400) && (response.data.modelState)) {
          var messages = [];
          for (var key in response.data.modelState) {
            if (response.data.modelState.hasOwnProperty(key)) {
              for (var i = 0; i < response.data.modelState[key].length; i++) {
                messages.push(response.data.modelState[key][i]);
              }
            }
          }
          dialog.alert(messages.join('<br/>'));
        }
      });

    };

  }]);
